import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=16cff277&scoped=true&"
import script from "./UsersTab.vue?vue&type=script&lang=js&"
export * from "./UsersTab.vue?vue&type=script&lang=js&"
import style0 from "./UsersTab.vue?vue&type=style&index=0&id=16cff277&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cff277",
  null
  
)

export default component.exports